var render = function render(){var _vm=this,_c=_vm._self._c;return _c('review-board',{attrs:{"course-source":"Special"}})
}
var staticRenderFns = []

export { render, staticRenderFns }